import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './ThumbnailFavoriteBadge.css';
import { useAsgActions } from '../../../../../shared/src/hooks/use-asg-actions.hook';
import { ToolsContext } from '../../../contexts';
import classNames from 'classnames';
import { GtmService } from '../../../../../shared/src/services/gtm.service';
import {
    GtmEventClickElement,
    GtmEventComponent,
    GtmEventLocation
} from '../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { useCurrentVerticalData } from '../../../../../shared/src/hooks/use-current-vertical-data.hook';

export const ThumbnailFavoriteBadge = ({
    gameId,
}) => {
    const [favoriteIconHover, setFavoriteIconHover] = useState(false);
    const badgeNameClass = 'casino-thumbnail__badge--favorite';
    const Tools = useContext(ToolsContext);
    const { async: {
        addFavoriteGame,
        removeFavoriteGame,
    } } = useAsgActions();
    const dispatch = useDispatch();
    const { isMobile } = useSelector((state) => state.app);
    const { favoriteGames } = useSelector(state => state.favorites);
    const isFavorite = favoriteGames.includes(gameId);
    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();
    const onClickHandler = (e) => {
        e.stopPropagation();
        const clickAction = isFavorite ? 'remove favorite' : 'add favorite';
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.GAMES_THUMBNAIL,
            click_element: GtmEventClickElement.ICON,
            click_action: clickAction,
            game_id: gameId,
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });

        if (isFavorite) {
            dispatch(removeFavoriteGame({ gameId, globals: { Tools } }));
        } else {
            dispatch(addFavoriteGame({ gameId, globals: { Tools } }));
        }
    };

    const wrapperClass = classNames(
        badgeNameClass,
        {
            'casino-thumbnail__hover-favorite': favoriteIconHover,
            'casino-thumbnail__favorite-init': !favoriteIconHover,
        }
    );

    const iconClassNames = classNames(
        'casino-thumbnail__favorite-icon',
        {
            'casino-thumbnail__favorite-icon--hover': favoriteIconHover && !isFavorite,
            'casino-thumbnail__favorite-icon--checked': isFavorite,
        }
    );

    return (
        <div
            className={wrapperClass}
            onClick={onClickHandler}
        >
            <div
                className={iconClassNames}
                onMouseEnter={() => { !isMobile && setFavoriteIconHover(true); }}
                onMouseLeave={() => { !isMobile && setFavoriteIconHover(false); }}
            />
        </div>
    );
};
